import React from 'react';

const OurStory = () => {
  return (
    <section id="about" className="our-story">
      <div className="story-content">
        <h2>OUR STORY</h2>
        <p>We're not just another spirits brand; we're a standard. Born in Yorkshire, Fire House Spirits was built on a single idea: to create a bougie, unique, and modern experience.</p>
        <p>We curate and present small batch spirits that have a story. This is craftsmanship, bottled with intent.</p>
        <p>Welcome to the house.</p>
      </div>
    </section>
  );
};

export default OurStory;
